import { loginService } from './login.service';
import { getSubdomainFranchise } from '../utils/get-subdomain';

class HttpInterceptor {
  private baseUrl: string;
  private subdomain: string;
  private urlsToSkip: string[];

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_URL || 'https://xdoinfinitto.com.br:3000';
    this.subdomain = getSubdomainFranchise();
    this.urlsToSkip = ['/user/login', '/user/refresh', '/user/register','/franchise/available'];    
  }

  
    
  isUrlToSkipToken(url: string): boolean {
    // do a search in the string of the url for each url to skip in the list
    return this.urlsToSkip.some(skipUrl => url.includes(skipUrl));
  }

  async request(url: string, options: RequestInit = {}): Promise<Response> {
    
    // Adicionar headers padrão
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': btoa(this.subdomain),
      ...options.headers,
    };

    // Adicionar token de autorização se disponível
    const token = localStorage.getItem('token');
    if (token && !this.isUrlToSkipToken(url)) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const requestOptions: RequestInit = {
      ...options,
      headers,
    };
    let response: Response;
    try {
      response = await fetch(`${this.baseUrl}${url}`, requestOptions);

      // Se token expirou, tentar renovar
      if (response.status === 401 && !this.isUrlToSkipToken(url)) {
        const refreshSuccess = await this.refreshToken();
        
        if (refreshSuccess) {
          // Repetir a requisição com o novo token
          const newToken = localStorage.getItem('token');
          if (newToken) {
            //console.log('Token renovado com sucesso (', newToken.substring(0, 5), '...)');
            headers['Authorization'] = `Bearer ${newToken}`;
            return await fetch(`${this.baseUrl}${url}`, {
              ...requestOptions,
              headers,
            });
          }
        } else {
          // Redirecionar para login se não conseguir renovar o token
          //this.redirectToLogin();
          window.location.href = '/authentication/side-login';
          console.error(`Token expired and refresh failed (${url})`);
          throw new Error('Token expired and refresh failed');
        }
      }

      return response;
    } catch (error) {
      console.error(`HTTP Request Error (${url} -  ${response?.status || '?? '} > ${response?.statusText || '??'}):`, error);
      throw error;
    }
  }

  async get(url: string, options?: RequestInit): Promise<Response> {
    return this.request(url, { ...options, method: 'GET' });
  }

  async post(url: string, data?: any, options?: RequestInit): Promise<Response> {
    return this.request(url, {
      ...options,
      method: 'POST',
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async put(url: string, data?: any, options?: RequestInit): Promise<Response> {
    return this.request(url, {
      ...options,
      method: 'PUT',
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async patch(url: string, data?: any, options?: RequestInit): Promise<Response> {
    return this.request(url, {
      ...options,
      method: 'PATCH',
      body: data ? JSON.stringify(data) : undefined,
    });
  }

  async delete(url: string, options?: RequestInit): Promise<Response> {
    return this.request(url, { ...options, method: 'DELETE' });
  }

  private async refreshToken(): Promise<boolean> {
    const refreshToken = localStorage.getItem('refreshToken');
    const user = localStorage.getItem('userlogged');
    const email = user ? JSON.parse(user).email : null;

    if (!refreshToken || !email) {
        return false;
    }

    try {
      const response = await loginService.refreshToken(refreshToken, email);
      
      if (response.idToken && response.refreshToken) {
        localStorage.setItem('token', response.idToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Token refresh failed:', error);
      return false;
    }
  }

  private redirectToLogin(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userlogged');
    window.location.href = '/authentication/side-login';
  }
}

export const httpInterceptor = new HttpInterceptor();
